/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_USERS_BEGIN,
  LIST_USERS_SUCCESS,
  LIST_USERS_ERR,

  CREATE_USER_BEGIN,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERR,

  UPDATE_USER_BEGIN,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERR,

  DELETE_USER_BEGIN,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERR,

  BLOCK_USER_BEGIN,
  BLOCK_USER_SUCCESS,
  BLOCK_USER_ERR,

  UNBLOCK_USER_BEGIN,
  UNBLOCK_USER_SUCCESS,
  UNBLOCK_USER_ERR,

  GET_USER_DETAILS_BEGIN,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateUser: false,
  errorCreateUser: "",
  loadingUpdateUser: false,
  errorUpdateUser: "",
  users: [],
  totalUsers: 0,
  totalUsersPages: 0,
  loadingDeleteUser: false,
  errorDeleteUser: "",
  loadingBlockUser: false,
  errorBlockUser: null,
  loadingUnblockUser: false,
  errorUnblockUser: null,
  loadingGetUserDetails: false,
  errorGetUserDetails: null,
  userDetails: {},
};

const usersReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_USER_BEGIN:
      return {
        ...state,
        loadingCreateUser: true,
        errorCreateUser: "",
      };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        users: [...state.users, data],
        loadingCreateUser: false,
        errorCreateUser: "",
      };
    case CREATE_USER_ERR:
      return {
        ...state,
        errorCreateUser: err,
        loadingCreateUser: false,
      };

    case LIST_USERS_BEGIN:
      return {
        ...state,
        loadingListUsers: true,
        errorListUsers: false,
        totalUsers: 0,
        totalUsersPages: 0,
      };
    case LIST_USERS_SUCCESS:
      return {
        ...state,
        users: [...data.results],
        loadingListUsers: false,
        errorListUsers: null,
        totalUsers: data.total_count,
        totalUsersPages: data.total_pages,
      };
    case LIST_USERS_ERR:
      return {
        ...state,
        errorListUsers: err,
        loadingListUsers: false,
        totalUsers: 0,
        totalUsersPages: 0,
      };

    case UPDATE_USER_BEGIN:
      return {
        ...state,
        loadingUpdateUser: true,
        errorUpdateUser: false,
      };
    case UPDATE_USER_SUCCESS:
      const updatedUsers = state.users.map((user) =>
        user.id === data.id ? { ...user, ...data } : user
      );
      return {
        ...state,
        users: updatedUsers,
        loadingUpdateUser: false,
        errorUpdateUser: null,
      };
    case UPDATE_USER_ERR:
      return {
        ...state,
        errorUpdateUser: err,
        loadingUpdateUser: false,
      };

    case DELETE_USER_BEGIN:
      return {
        ...state,
        loadingDeleteUser: true,
        errorDeleteUser: null,
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== data.id),
        loadingDeleteUser: false,
        errorDeleteUser: null,
      };
    case DELETE_USER_ERR:
      return {
        ...state,
        errorDeleteUser: err,
        loadingDeleteUser: false,
      };

    case BLOCK_USER_BEGIN:
      return {
        ...state,
        loadingBlockUser: true,
        errorBlockUser: null,
      };
    case BLOCK_USER_SUCCESS:
      return {
        ...state,
        loadingBlockUser: false,
        errorBlockUser: null,
      };
    case BLOCK_USER_ERR:
      return {
        ...state,
        errorBlockUser: err,
        loadingBlockUser: false,
      };

    case UNBLOCK_USER_BEGIN:
      return {
        ...state,
        loadingUnblockUser: true,
        errorUnblockUser: null,
      };
    case UNBLOCK_USER_SUCCESS:
      return {
        ...state,
        loadingUnblockUser: false,
        errorUnblockUser: null,
      };
    case UNBLOCK_USER_ERR:
      return {
        ...state,
        loadingUnblockUser: false,
        errorUnblockUser: err,
      };

    case GET_USER_DETAILS_BEGIN:
      return {
        ...state,
        userDetails: {},
        loadingGetUserDetails: true,
        errorGetUserDetails: null,
      };
    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: data,
        loadingGetUserDetails: false,
        errorGetUserDetails: null,
      };
    case GET_USER_DETAILS_ERR:
      return {
        ...state,
        userDetails: {},
        loadingGetUserDetails: false,
        errorGetUserDetails: err,
      };

    default:
      return state;
  }
};

export { usersReducer };
